import { featureCollection } from "@turf/turf";
import { GeoJSONSource } from "mapbox-gl";
import { useEffect } from "react";

import { useGaiaMap } from "../../hooks/useGaiaMap";

type Props = {
    id: string;
    data?: GeoJSON.GeoJSON;
};

export default function GaiaMapDataLayer({ id, data }: Props) {
    const { map } = useGaiaMap();

    // Add / remove data source
    useEffect(() => {
        if (!map) return;
        if (!map.getSource(id)) {
            map.addSource(id, {
                type: "geojson",
                data: featureCollection([]),
                generateId: true,
            });
        }
    }, [map, id]);

    // Update source data
    useEffect(() => {
        if (!map || !data) return;
        const source: GeoJSONSource | undefined = map.getSource(id);
        if (!source) return;
        source.setData(data);
    }, [map, id, data]);

    // For re-adding the source if the map changes between satalite / street view
    useEffect(() => {
        function onStyleLoad() {
            if (!map || map.getSource(id)) return;
            map.addSource(id, {
                type: "geojson",
                data: data,
                generateId: true,
            });
        }
        map?.on("style.load", onStyleLoad);
        return () => {
            map?.off("style.load", onStyleLoad);
        };
    }, [map, id, data]);

    return <></>;
}
